import { render } from "./LegalPerson.vue?vue&type=template&id=51671718"
import script from "./LegalPerson.vue?vue&type=script&lang=js"
export * from "./LegalPerson.vue?vue&type=script&lang=js"

import "./LegalPerson.vue?vue&type=style&index=0&id=51671718&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__